import { apiClient } from './client';
import {
  BrgGoalDto,
  CreateGoalRequest,
  UpdateGoalRequest,
  UpdateGoalStatusRequest,
  GoalsFilterParams,
} from '../types';

export const goalsApi = {
  list(params?: GoalsFilterParams): Promise<BrgGoalDto[]> {
    const queryParams = new URLSearchParams();
    if (params?.brgId) queryParams.append('brgId', params.brgId);
    if (params?.fiscalYear) queryParams.append('fiscalYear', params.fiscalYear);
    if (params?.pillar) queryParams.append('pillar', params.pillar);

    const queryString = queryParams.toString();
    const path = queryString ? `/api/goals?${queryString}` : '/api/goals';
    return apiClient.get<BrgGoalDto[]>(path);
  },

  getById(id: string): Promise<BrgGoalDto> {
    return apiClient.get<BrgGoalDto>(`/api/goals/${id}`);
  },

  create(data: CreateGoalRequest): Promise<BrgGoalDto> {
    return apiClient.post<BrgGoalDto>('/api/goals', data);
  },

  createMultiple(data: CreateGoalRequest[]): Promise<BrgGoalDto[]> {
    return apiClient.post<BrgGoalDto[]>('/api/goals/batch', data);
  },

  update(id: string, data: UpdateGoalRequest): Promise<BrgGoalDto> {
    return apiClient.patch<BrgGoalDto>(`/api/goals/${id}`, data);
  },

  updateStatus(id: string, data: UpdateGoalStatusRequest): Promise<BrgGoalDto> {
    return apiClient.patch<BrgGoalDto>(`/api/goals/${id}/status`, data);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete<void>(`/api/goals/${id}`);
  },
};
